import React from "react"
import PropTypes from "prop-types"
import { UID } from "react-uid"

import Field from "./Field"
import Label from "../atoms/Label"
import H6 from "../atoms/H6"
import Radio from "../atoms/Radio"
import TextArea from "../atoms/TextArea"
import TextInput from "../atoms/TextInput"

import styles from "./Input.module.css"

const inputTypes = {
  honeypot: "honeypot",
  number: "number",
  radio: "radio",
  text: "text",
  textarea: "textarea",
}

class Input extends React.Component {
  renderRadio() {
    return (
      <UID>
        {id => {
          const fieldId = `radio${id}`
          return (
            <div className={styles.radioContainer}>
              <div className={styles.booleanContainer}>
                <Radio
                  id={fieldId}
                  name={this.props.name}
                  value={this.props.value}
                  required={this.props.required}
                />
              </div>
              <div className={styles.booleanLabelContainer}>
                <Label htmlFor={fieldId} type="secondary">
                  {this.props.label}
                </Label>
              </div>
            </div>
          )
        }}
      </UID>
    )
  }

  renderTextInput() {
    return (
      <UID>
        {id => {
          const fieldId = `textInput${id}`
          const fieldType =
            this.props.type === inputTypes.honeypot
              ? inputTypes.text
              : this.props.type
          return (
            <Field>
              <Label htmlFor={fieldId}>{this.props.label}</Label>
              <div>
                <TextInput
                  type={fieldType}
                  id={fieldId}
                  name={this.props.name}
                  placeholder={this.props.placeholder}
                  min={this.props.min}
                  max={this.props.max}
                  value={this.props.value}
                  required={this.props.required}
                />
              </div>
              <H6>{this.props.hint}</H6>
            </Field>
          )
        }}
      </UID>
    )
  }

  renderTextArea() {
    return (
      <UID>
        {id => {
          const fieldId = `textInput${id}`
          return (
            <Field>
              <Label htmlFor={fieldId}>{this.props.label}</Label>
              <div>
                <TextArea
                  id={fieldId}
                  name={this.props.name}
                  placeholder={this.props.placeholder}
                >
                  {this.props.children || this.props.value}
                </TextArea>
              </div>
            </Field>
          )
        }}
      </UID>
    )
  }

  renderHoneypot() {
    return (
      <div className={styles.hideContainer} aria-hidden="true">
        {this.renderTextInput()}
      </div>
    )
  }

  render() {
    switch (this.props.type) {
      case inputTypes.radio:
        return this.renderRadio()
      case inputTypes.textarea:
        return this.renderTextArea()
      case inputTypes.honeypot:
        return this.renderHoneypot()
      default:
        return this.renderTextInput()
    }
  }
}

Input.defaultProps = {
  type: inputTypes.primary,
}

Input.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(Object.values(inputTypes)),
  value: PropTypes.string,
}

export default Input
